/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontHome_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFeaturedSection_viewer">;
    readonly " $refType": "StorefrontHome_viewer";
};
export type StorefrontHome_viewer$data = StorefrontHome_viewer;
export type StorefrontHome_viewer$key = {
    readonly " $data"?: StorefrontHome_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontHome_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontHome_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'e604d626df963f5912fa6bbad941e3b7';
export default node;
